"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'dblogs.page.prev': '上一页',
    'dblogs.page.next': '下一页',
    'dblogs.page.info': '页面',
};
